import { ConfigEntryFieldType, ConfigEntryType } from 'config/config';
import TextInputField from './TextInputField';
import NumberField from './NumberField';
import DateField from './DateField';
import CheckboxField from './CheckboxField';
import RadioField from './RadioField';
import MultiKeywordsField from './MultiKeywordsField';
import PostSelectCustomField from 'components/modals/addPostModal/PostSelectCustomField';
import PostMultiSelectCustomField from 'components/modals/addPostModal/PostMultiSelectCustomField';
import useUserData from 'hooks/useUserData';
import PhoneNumberInputField from './PhoneNumberInputField';
import EditorField from './EditorField';
import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

type RenderFilterFieldByTypeProps = {
  autoFocus?: boolean;
  field: ConfigEntryType;
  articleType?: ArticleSourceType;
  showLabel?: boolean;
};

function RenderFilterFieldByType({
  autoFocus,
  field,
  articleType,
  showLabel,
}: RenderFilterFieldByTypeProps) {
  const { canAddProjects } = useUserData();

  // if (field.entryCode.toLowerCase() === 'divisions') {
  //   return <DivisionsField field={field} TextFieldProps={{ variant: 'standard' }} />;
  // }

  // if (field.entryCode.toLowerCase() === 'specsections') {
  //   return <SpecSectionsField field={field} TextFieldProps={{ variant: 'standard' }} />;
  // }

  if (field.entryCode.toLowerCase() === 'phonenumber') {
    return <PhoneNumberInputField field={field} />;
  }

  switch (field.referenceObject?.type || ConfigEntryFieldType.MULTI_SELECT) {
    case ConfigEntryFieldType.TEXT: {
      return <TextInputField field={field} showLabel={showLabel} />;
    }

    case ConfigEntryFieldType.EDITOR: {
      return <EditorField field={field} defaultHeight={75} articleType={articleType} />;
    }

    case ConfigEntryFieldType.NUMBER: {
      return <NumberField field={field} />;
    }

    case ConfigEntryFieldType.DATE: {
      return <DateField field={field} />;
    }

    case ConfigEntryFieldType.CHECKBOX: {
      return <CheckboxField field={field} />;
    }

    case ConfigEntryFieldType.RADIO: {
      return <RadioField field={field} />;
    }

    case ConfigEntryFieldType.SELECT: {
      return (
        <PostSelectCustomField
          autoFocus={autoFocus}
          field={field}
          TextFieldProps={{ variant: 'standard' }}
          showAddProject={canAddProjects}
          showLabel={showLabel}
        />
      );
    }

    case ConfigEntryFieldType.MULTI_SELECT: {
      return (
        <PostMultiSelectCustomField
          autoFocus={autoFocus}
          field={field}
          TextFieldProps={{ variant: 'standard' }}
          showAddProject={canAddProjects}
        />
      );
    }

    case ConfigEntryFieldType.REGEX: {
      return <MultiKeywordsField field={field} TextFieldProps={{ variant: 'standard' }} />;
    }

    default:
      return (
        <PostMultiSelectCustomField
          field={field}
          TextFieldProps={{ variant: 'standard' }}
          showAddProject={canAddProjects}
        />
      );
  }
}

export default RenderFilterFieldByType;
